/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BrokernetProductName } from '../model/brokernet-product-name.model';
// @ts-ignore
import { BrokernetProductType } from '../model/brokernet-product-type.model';
// @ts-ignore
import { ContractCustomerSearchGroupedResultDto } from '../model/contract-customer-search-grouped-result-dto.model';
// @ts-ignore
import { ContractCustomerSearchResultDtoPageResultDto } from '../model/contract-customer-search-result-dto-page-result-dto.model';
// @ts-ignore
import { ContractProductType } from '../model/contract-product-type.model';
// @ts-ignore
import { ContractStatus } from '../model/contract-status.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ContractCustomerSearchApiService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @endpoint get /api/contract-customer-search/customer/{customerId}
     * @param customerId 
     * @param pageNumber 
     * @param pageSize 
     * @param contractProductTypes 
     * @param brokernetProductTypes 
     * @param brokernetProductNames 
     * @param contractStatus 
     * @param orderByValues 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContractCustomerSearchCustomerCustomerIdGet(customerId: string, pageNumber: number, pageSize: number, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, orderByValues?: Array<string>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ContractCustomerSearchResultDtoPageResultDto>;
    public apiContractCustomerSearchCustomerCustomerIdGet(customerId: string, pageNumber: number, pageSize: number, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, orderByValues?: Array<string>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ContractCustomerSearchResultDtoPageResultDto>>;
    public apiContractCustomerSearchCustomerCustomerIdGet(customerId: string, pageNumber: number, pageSize: number, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, orderByValues?: Array<string>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ContractCustomerSearchResultDtoPageResultDto>>;
    public apiContractCustomerSearchCustomerCustomerIdGet(customerId: string, pageNumber: number, pageSize: number, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, orderByValues?: Array<string>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiContractCustomerSearchCustomerCustomerIdGet.');
        }
        if (pageNumber === null || pageNumber === undefined) {
            throw new Error('Required parameter pageNumber was null or undefined when calling apiContractCustomerSearchCustomerCustomerIdGet.');
        }
        if (pageSize === null || pageSize === undefined) {
            throw new Error('Required parameter pageSize was null or undefined when calling apiContractCustomerSearchCustomerCustomerIdGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (contractProductTypes) {
            contractProductTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractProductTypes');
            })
        }
        if (brokernetProductTypes) {
            brokernetProductTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'brokernetProductTypes');
            })
        }
        if (brokernetProductNames) {
            brokernetProductNames.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'brokernetProductNames');
            })
        }
        if (contractStatus) {
            contractStatus.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractStatus');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNumber, 'PageNumber');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'PageSize');
        if (orderByValues) {
            orderByValues.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OrderByValues');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/contract-customer-search/customer/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ContractCustomerSearchResultDtoPageResultDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @endpoint get /api/contract-customer-search/customer/{customerId}/grouped
     * @param customerId 
     * @param contractProductTypes 
     * @param brokernetProductTypes 
     * @param brokernetProductNames 
     * @param contractStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiContractCustomerSearchCustomerCustomerIdGroupedGet(customerId: string, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ContractCustomerSearchGroupedResultDto>>;
    public apiContractCustomerSearchCustomerCustomerIdGroupedGet(customerId: string, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ContractCustomerSearchGroupedResultDto>>>;
    public apiContractCustomerSearchCustomerCustomerIdGroupedGet(customerId: string, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ContractCustomerSearchGroupedResultDto>>>;
    public apiContractCustomerSearchCustomerCustomerIdGroupedGet(customerId: string, contractProductTypes?: Array<ContractProductType>, brokernetProductTypes?: Array<BrokernetProductType>, brokernetProductNames?: Array<BrokernetProductName>, contractStatus?: Array<ContractStatus>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiContractCustomerSearchCustomerCustomerIdGroupedGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (contractProductTypes) {
            contractProductTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractProductTypes');
            })
        }
        if (brokernetProductTypes) {
            brokernetProductTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'brokernetProductTypes');
            })
        }
        if (brokernetProductNames) {
            brokernetProductNames.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'brokernetProductNames');
            })
        }
        if (contractStatus) {
            contractStatus.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractStatus');
            })
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Bearer) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Bearer', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/contract-customer-search/customer/${this.configuration.encodeParam({name: "customerId", value: customerId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/grouped`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ContractCustomerSearchGroupedResultDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
